import { CustomerAPI, ConversationAPI, DriftAPI, json, checkStatus, IntegrationAPI, SyncjobAPI } from '@driftt/dapper'
import { CustomerAPIAuthEnabled } from 'app/auth-requests/api'
import { prop } from 'ramda'
import { encodeQueryData } from 'utils/Helpers'

export const saveDemandbaseApiKey = (apiKey) => {
  return CustomerAPI
    .post(`/integrations/demandbase/access_token`, { token: apiKey })
    .then(checkStatus)
}

export const saveMadKuduApiKey = (apiKey) => {
  return CustomerAPI
    .post(`/integrations/madkudu/access_token`, { token: apiKey })
    .then(checkStatus)
}

export const connectMarketo = ({ munchkinId, clientId, clientSecret }) => {
  return CustomerAPI
    .post('/integrations/marketo/config', { munchkinId, clientId, clientSecret })
    .then(checkStatus)
}

export const searchForMarketoActivity = (searchTerm) => {
  return CustomerAPI
    .get(`/integrations/marketo/activities/types?search=${searchTerm}`)
    .then(checkStatus)
    .then(json)
}

export const getMarketoToggles = () => {
  return CustomerAPI
    .get(`/integrations/marketo/toggles`)
    .then(checkStatus)
    .then(json)
}

export const patchMarketoToggles = data => {
  return CustomerAPI
    .patch(`/integrations/marketo/toggles`, data)
    .then(checkStatus)
    .then(json)
}

export const setMarketoLeadOwnerField = leadOwnerField => {
  return CustomerAPI
    .patch(`/marketo/owner/field`, { leadOwnerField })
    .then(checkStatus)
    .then(json)
}

export const getMarketoLeadOwnerField = () => {
  return CustomerAPI
    .get(`/marketo/owner/field`)
    .then(checkStatus)
    .then(json)
    .then(prop('leadOwnerField'))
}

export const queryMarketoPrograms = (query) => {
  return SyncjobAPI
    .get(`/marketo/programs?q=${query}&offset=0&maxReturn=50`)
    .then(checkStatus)
    .then(json)
}

export const fetchMarketoPrograms = () => {
  return SyncjobAPI
    .post('/marketo/programs/fetch', {})
    .then(checkStatus)
    .then(json)
}

export const getDefaultMarketoProgram = () => {
  return CustomerAPI
    .get(`/marketo/programs/default`)
    .then(checkStatus)
    .then(json)
}

export const setDefaultMarketoProgram = (programName, assignOnlyOnCreate) => {
  return CustomerAPI
    .post(`/marketo/programs/default?programName=${programName}&assignOnlyOnCreate=${assignOnlyOnCreate}`)
    .then(checkStatus)
    .then(json)
}

export const deleteDefaultMarketoProgram = () => {
  return CustomerAPI
    .delete(`/marketo/programs/default`)
    .then(checkStatus)
    .then(json)
}

export const setMinimumCqlScore = data => {
  return CustomerAPI
  .patch(`/integrations/minimum_cql_score`, data) // ex: { integrationName: 'salesforce', 'score': 1}
  .then(checkStatus)
  .then(json)
}

export const getMinimumCqlScore = integrationName => {
  return CustomerAPI
  .get(`/integrations/minimum_cql_score?integrationName=${integrationName}`)
  .then(checkStatus)
  .then(json)
}

export const getSalesforceToggles = () => {
  return CustomerAPI
    .get(`/salesforce/toggles`)
    .then(checkStatus)
    .then(json)
}

export const patchSalesforceToggles = data => {
  return CustomerAPI
    .patch(`/salesforce/toggles`, data)
    .then(checkStatus)
    .then(json)
}

export const getEloquaConfig = () => {
  return IntegrationAPI
    .get(`/eloqua/config`)
    .then(checkStatus)
    .then(json)
}

export const patchEloquaConfig = data => {
  return IntegrationAPI
    .patch(`/eloqua/config`, data)
    .then(checkStatus)
    .then(json)
}

export const patchPardotConfig = data => {
  return IntegrationAPI
    .patch('/pardot/config', data)
    .then(checkStatus)
    .then(json)
}

export const getPardotConfig = () => {
  return IntegrationAPI
    .get('/pardot/config')
    .then(checkStatus)
    .then(json)
}

export const getPardotTranscriptField = () => {
  return IntegrationAPI
    .get('/pardot/config')
    .then(checkStatus)
    .then(json)
    .then(json => json.conversationTranscriptField)
}

export const setPardotTranscriptField = transcriptField => {
  const payload = { 'conversationTranscriptField' : transcriptField }
  return IntegrationAPI
    .patch('/pardot/config', payload)
    .then(checkStatus)
    .then(json)
}

export const setPardotLeadOwnerField = leadOwnerField => {
  return IntegrationAPI
    .patch(`/pardot/owner/field`, { leadOwnerField })
    .then(checkStatus)
    .then(json)
}

export const getPardotLeadOwnerField = () => {
  return IntegrationAPI
    .get(`/pardot/owner/field`)
    .then(checkStatus)
    .then(json)
    .then(prop('leadOwnerField'))
}

export const authenticatePardot = (connectPayload) => {
  return IntegrationAPI.post('/pardot/install-integration', connectPayload)
    .then(checkStatus)
    .then(json)
}

export const getHubspotToggles = () => {
  return CustomerAPI
    .get(`/integrations/hubspot/toggles`)
    .then(checkStatus)
    .then(json)
}
export const patchSlackNotificationToggle = data => {
  return CustomerAPI
    .patch(`/integrations/slack/notifications`, data)
    .then(checkStatus)
}

export const getSlackNotificationToggle = () => {
  return CustomerAPI
    .get(`/integrations/slack/notifications`)
    .then(checkStatus)
    .then(json)
}

export const patchHubspotToggles = data => {
  return CustomerAPI
    .patch(`/integrations/hubspot/toggles`, data)
    .then(checkStatus)
    .then(json)
}

export const fetchMarketoMappedActivities = () => {
  return CustomerAPI
    .get(`/integrations/marketo/activities/mapped`)
    .then(checkStatus)
    .then(json)
}

export const deleteMarketoMappedActivity = (activityType) => {
  return CustomerAPI
    .delete(`/integrations/marketo/activities/mapped?activity-type=${activityType}`)
    .then(checkStatus)
    .then(json)
}

export const patchMarketoMappedActivities = (activities) => {
  return CustomerAPI
    .patch(`/integrations/marketo/activities/mapped`, activities)
    .then(checkStatus)
}

export const toggleLinkedinIntegration = (isEnabled) => {
  return CustomerAPI
    .patch(`/integrations/linkedin/toggles`, { enabled: isEnabled })
    .then(checkStatus)
}

export const toggleVidyardIntegration = (isEnabled) => {
  return CustomerAPI
    .patch(`/integrations/vidyard/toggles`, { enabled: isEnabled })
    .then(checkStatus)
}

export const fetchInstalledApps = () => {
  return CustomerAPIAuthEnabled
    .get('/integrations/external')
    .then(res => res.data)
    .then(data => data.integrations)
}

export const postIntegrationSuggestion = (suggestion) => {
  return CustomerAPI
    .post(`/integrationsuggestions?suggestion=${suggestion}`)
    .then(checkStatus)
}

export const uninstallInstalledApp = (id) => {
  return CustomerAPI
    .post(`/integrations/external/${id}/uninstall`)
    .then(checkStatus)
    .then(json)
}

export const fetchApp = (id) => {
  return CustomerAPI
    .get(`/integrations/external/${id}`)
    .then(checkStatus)
    .then(json)
}

export const fetchAppScopes = (id) => {
  return CustomerAPI
    .get(`/integrations/external/${id}/scopes`)
    .then(checkStatus)
    .then(json)
    .then(data => data.scopes)
}

export const authorizeApp = (id) => {
  return CustomerAPI
    .post(`/integrations/external/${id}/authorize`)
    .then(checkStatus)
    .then(json)
}

export const getGoogleScopes = () => {
  return CustomerAPI
    .get(`/google/calendar/oauth/scopes`)
    .then(json)
}

export const getIntegrationStates = () => {
  return CustomerAPIAuthEnabled
    .get(`/integrations/all/public`)
    .then(res => res.data)
}

export const getIntegrationEventLog = query => getIntegrationEventLogQueryStr(encodeQueryData(query))

export const getIntegrationEventLogQueryStr = queryStr => {
  return DriftAPI.get(`/business/events/auth?${queryStr}`)
    .then(checkStatus)
    .then(json)
}

export const emailBusinessCsvExport = payload => {
  return DriftAPI.post(`/business/events/export/csv`, payload)
    .then(checkStatus)
}

export const enableClearbitEnrichment = () => {
  return CustomerAPI.post('/integrations/clearbit/toggles/enrichment', { enabled: true })
    .then(checkStatus)
    .then(json)
    .then(response => response.data)
}

export const disableClearbitEnrichment = () => {
  return CustomerAPI.patch('/integrations', { clearbit_enrichment: false })
    .then(checkStatus)
    .then(json)
    .then(response => response.data)
}

export const enableClearbitReveal = (apiKey) => {
  return CustomerAPI.post('/integrations/clearbit/properties/reveal_api_key', { apiKey })
    .then(checkStatus)
    .then(json)
    .then(response => response.data)
}

export const disableClearbitReveal = () => {
  return CustomerAPI.patch('/integrations', { clearbit_reveal: false })
    .then(checkStatus)
    .then(json)
    .then(response => response.data)
}

export const fetchClearbitApiKeyOwner = () => {
  return CustomerAPI.get('/integrations/clearbit/properties/reveal_api_key/owner')
    .then(checkStatus)
    .then(json)
}

export const fetchFacebookSettings = () => (
  CustomerAPI.get('/integrations/facebook_analytics')
    .then(checkStatus)
    .then(json)
)

export const fetchStripeKeys = () => (
  CustomerAPI.get('/integrations/stripe/keys')
    .then(checkStatus)
    .then(json)
)

export const fetchOutreachStatus = (orgId) => (
  CustomerAPI.get('/integrations/outreach/install_status/internal')
    .then(checkStatus)
    .then(json)
)

export const createAccessToken = (integrationName, body) => {
  return CustomerAPI.post(`/integrations/${integrationName}/access_token`, body)
    .then(checkStatus)
    .then(json)
}

export const createSlackbotToken = (code, href) => {
  const queryParams = (href != null) ? encodeQueryData({ redirectUri: href }) : ''
  return CustomerAPI.post(`/integrations/slack/activate_bot?${ queryParams }`, { code })
    .then(checkStatus)
    .then(json)
}

export const updateIntegrationState = ({ integration, connected }) => {
  return CustomerAPI.patch('/integrations', { [integration]: connected })
    .then(checkStatus)
    .then(json)
}

export const setWordpressDomain = rootUrl => (
  CustomerAPI.post('/integrations/wordpress/v2', { rootUrl })
    .then(checkStatus)
)

export const fetchWordpressDomain = () => (
  CustomerAPI.get('/integrations/wordpress/v2')
    .then(checkStatus)
    .then(json)
)

export const getLeanDataAuthorizationStatus = () => {
  return ConversationAPI.get('/integration/test/leandata/authorization')
    .then(json)
}

export const getIntegrationErrorAdminSettings = () => {
  return CustomerAPI.get('/integrations/admin/notification/error')
  .then(json)
}

export const patchIntegrationErrorAdminSettings = (data) => {
  return CustomerAPIAuthEnabled.patch('/integrations/admin/notification/error', data)
}

export const getIntegrationRetryDelay = (integration) => {
  return CustomerAPI.get(`/integrations/delay_time/${integration}`).then(checkStatus).then(json)
}
export const setIntegrationRetryDelay = (delay, integration) => {
  return CustomerAPI.post(`/integrations/delay_time/${integration}`, {retryDelayInMinutes: delay}, {
    headers: { 'Content-Type': 'application/json' }})
    .then(checkStatus)
    .then(json)
}


// WEBPACK FOOTER //
// ./src/scripts/app/modules/integrations/api.js